import { render, staticRenderFns } from "./SectionItemProductList.vue?vue&type=template&id=56705d02&scoped=true&"
import script from "./SectionItemProductList.vue?vue&type=script&lang=ts&"
export * from "./SectionItemProductList.vue?vue&type=script&lang=ts&"
import style0 from "./SectionItemProductList.vue?vue&type=style&index=0&id=56705d02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56705d02",
  null
  
)

export default component.exports